import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {
  Icon, UiEmbed,
} from '@powdr/components';

import { OverlayImage } from '..';

import {
  SlideContent,
  HeroIconWrapper,
  CopyHeader,
  CopyContent,
  SlideButton,
  CopyHeaderEmbedded,
} from './styles';

export const HeroSlideContent = ({
  isMobile,
  isAltCopyDisplay,
  contentAlignment,
  imageInContent,
  hasOverlayImage,
  embeddedVideoLink,
  title,
  copy,
  heroIcon,
  heroIconWidth,
  buttonHref,
  buttonTarget,
  buttonText,
  relationships,
  imageWidth,
  imageWidthMobile,
  copyBackgroundColor,
  copyBackgroundColorValue,
  isDisableTextShadow,
}) => {
  const altCopy = isMobile ? false : isAltCopyDisplay;

  if (!imageInContent && hasOverlayImage) {
    return (
      <OverlayImage
        imageData={relationships.overlayImage}
        imageWidth={imageWidth || 50}
        imageWidthMobile={imageWidthMobile || 100}
        href={buttonHref}
        target={buttonTarget}
        isInContent={false}
      />
    );
  }

  return (
    <SlideContent
      className={copyBackgroundColor}
      $isAltCopyDisplay={altCopy}
      $contentAlignment={contentAlignment}
    >
      {embeddedVideoLink ? (
        <UiEmbed videoLink={embeddedVideoLink}>
          <CopyHeaderEmbedded
            $colorProfile={copyBackgroundColorValue}
            $isDisableTextShadow={isDisableTextShadow}
            $isDisablePadding={!copy}
          >
            {title}
          </CopyHeaderEmbedded>
        </UiEmbed>
      ) : (
        <>
          {imageInContent && (
            <OverlayImage
              imageData={relationships.overlayImage}
              imageWidth={imageWidth || 50}
              imageWidthMobile={imageWidthMobile || 100}
              href={buttonHref}
              target={buttonTarget}
              isInContent
            />
          )}
          {heroIcon && (
            <HeroIconWrapper>
              <Icon name={heroIcon} width={heroIconWidth || 50} />
            </HeroIconWrapper>
          )}
          {title && (
            <CopyHeader
              className={classNames('animated fadeInUp')}
              $colorProfile={copyBackgroundColorValue}
              $isDisableTextShadow={isDisableTextShadow}
              $isDisablePadding={!copy}
            >
              {title}
            </CopyHeader>
          )}
          {copy && (
            <CopyContent
              className={classNames('animated fadeInUp')}
              $colorProfile={copyBackgroundColorValue}
              $isDisableTextShadow={isDisableTextShadow}
              role="heading"
              aria-level="2"
            >
              {copy}
            </CopyContent>
          )}
          {buttonText && (
            <SlideButton href={buttonHref} target={buttonTarget}>
              {buttonText}
            </SlideButton>
          )}
        </>
      )}
    </SlideContent>
  );
};

HeroSlideContent.propTypes = {
  isMobile: PropTypes.bool,
  isAltCopyDisplay: PropTypes.bool,
  contentAlignment: PropTypes.string,
  imageInContent: PropTypes.bool,
  hasOverlayImage: PropTypes.bool,
  embeddedVideoLink: PropTypes.string,
  title: PropTypes.string,
  copy: PropTypes.string,
  heroIcon: PropTypes.string,
  heroIconWidth: PropTypes.number,
  buttonHref: PropTypes.string,
  buttonTarget: PropTypes.string,
  buttonText: PropTypes.string,
  relationships: PropTypes.shape({
    overlayImage: PropTypes.shape({}),
  }),
  imageWidth: PropTypes.number,
  imageWidthMobile: PropTypes.number,
  copyBackgroundColor: PropTypes.string,
  copyBackgroundColorValue: PropTypes.string,
  isDisableTextShadow: PropTypes.bool,
};
